import { addMethod, string } from 'yup';
import { buildMetadata, isAddressFieldOptional } from '../../../../../address/address-fields/address-schema';
import { FIELD_NAMES } from '../../../../../address/address-fields/constants';
import { buildMessageCallback } from '../../../../../validation/utilities';
import { WalletAddressSchema } from '../../../../components/wallet-address/wallet-address-schema';
import { messages } from './message';

const { LINE1, COUNTRY_CODE } = FIELD_NAMES;

const isNotPoBox = 'isNotPoBox';
const IS_NOT_PO_BOX = 'is-not-po-box';

addMethod(string, isNotPoBox, function (messageCallback) {
  return this.test(IS_NOT_PO_BOX, messageCallback, (value) => {
    if (!value) {
      return false;
    }
    const isPOBox = /^P\.?\s?O\.?\s?Box/i;
    return !isPOBox.test(value);
  });
});

export const PickupAddressSchema = WalletAddressSchema.shape({
  [LINE1]: string()
    .isNotPoBox(buildMessageCallback(messages.poBoxValidationError))
    .meta(buildMetadata(LINE1))
    .when(COUNTRY_CODE, isAddressFieldOptional),
});
